import {css} from "@panda/css";

import {ArrowIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

export interface IHeaderData {
    count?: number;
    price?: number;
    percent?: number | null;
}

interface IProps {
    data: IHeaderData;
    type: HeaderBoxType;
}

export enum HeaderBoxType {
    FLATS_COUNT,
    PRICE,
    PRICE_M2,
    MEDIAN_PRICE_M2
}

export const HeaderBox = (props: IProps) => {
    let boxText;

    switch (props.type) {
        case HeaderBoxType.FLATS_COUNT:
            boxText = "Liczba mieszkań";
            break;
        case HeaderBoxType.PRICE:
            boxText = "Średnia cena ofertowa";
            break;
        case HeaderBoxType.PRICE_M2:
            boxText = (
                <>
                    Średnia cena za m<sup>2</sup>
                </>
            );

            break;
        case HeaderBoxType.MEDIAN_PRICE_M2:
            boxText = (
                <>
                    Mediana ceny za m<sup>2</sup>
                </>
            );

            break;
        default:
            boxText = "Liczba nieruchomości";
    }

    // A missing year-ago row makes calculatePercent divide by zero, so the raw value can be Infinity or NaN.
    const percent = typeof props.data?.percent === "number" && Number.isFinite(props.data.percent) ? props.data.percent : null;

    return (
        <div className={infoBoxStyle}>
            <div>
                <Text variant="headline_2" as="p" className={priceStyle}>
                    {props.data?.price && priceFormat(props.data.price)}
                    {props.data?.count && props.data.count}
                </Text>
                <Text variant="body_copy_2">{boxText}</Text>
            </div>
            <div className={smallBoxStyle}>
                <div>
                    <Text variant="body_copy_2" strong align="center" className={percentStyle}>
                        {percent === null ? "-" : percent > 0 ? `+${percent}%` : `${percent}%`}
                        {percent !== null && percent !== 0 ? (
                            <ArrowIcon size="2" fill="#fff" className={percent > 0 ? arrowUpStyle : arrowDownStyle} />
                        ) : (
                            <span className={lineStyle} />
                        )}
                    </Text>
                </div>
                <Text variant="info_txt_3">Rok do roku</Text>
            </div>
        </div>
    );
};

const infoBoxStyle = css({
    backgroundColor: "var(--colors-primary)",
    padding: 3,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    width: "100%",
    maxWidth: "360px",
    md: {
        // RP-795: the row carries up to 4 tiles now - equal flex shares replace the former 25% / 33% caps, which overflowed with the median tile added
        flex: "1 1 0",
        minWidth: 0,
        justifyContent: "center"
    }
});

const priceStyle = css({
    marginBottom: 0.5
});

const smallBoxStyle = css({
    backgroundColor: "var(--colors-secondary)",
    color: "var(--colors-white)",
    padding: 1,
    borderRadius: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 1
});

const percentStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const arrowUpStyle = css({
    marginLeft: 1,
    transform: "scale(2) rotate(90deg)"
});

const arrowDownStyle = css({
    marginLeft: 1,
    transform: "scale(2) rotate(-90deg)"
});

const lineStyle = css({
    display: "inline-block",
    width: "0.8rem",
    height: "1px",
    marginLeft: 1,
    border: "1px solid white"
});
import {css} from "@panda/css";

import {ArrowIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";

export interface IHeaderData {
    count?: number;
    price?: number;
    percent?: number | null;
}

interface IProps {
    data: IHeaderData;
    type: HeaderBoxType;
}

export enum HeaderBoxType {
    FLATS_COUNT,
    PRICE,
    PRICE_M2,
    MEDIAN_PRICE_M2
}

export const HeaderBox = (props: IProps) => {
    let boxText;

    switch (props.type) {
        case HeaderBoxType.FLATS_COUNT:
            boxText = "Liczba mieszkań";
            break;
        case HeaderBoxType.PRICE:
            boxText = "Średnia cena ofertowa";
            break;
        case HeaderBoxType.PRICE_M2:
            boxText = (
                <>
                    Średnia cena za m<sup>2</sup>
                </>
            );

            break;
        case HeaderBoxType.MEDIAN_PRICE_M2:
            boxText = (
                <>
                    Mediana ceny za m<sup>2</sup>
                </>
            );

            break;
        default:
            boxText = "Liczba nieruchomości";
    }

    // A missing year-ago row makes calculatePercent divide by zero, so the raw value can be Infinity or NaN.
    const percent = typeof props.data?.percent === "number" && Number.isFinite(props.data.percent) ? props.data.percent : null;

    return (
        <div className={infoBoxStyle}>
            <div>
                <Text variant="headline_2" as="p" className={priceStyle}>
                    {props.data?.price && priceFormat(props.data.price)}
                    {props.data?.count && props.data.count}
                </Text>
                <Text variant="body_copy_2">{boxText}</Text>
            </div>
            <div className={smallBoxStyle}>
                <div>
                    <Text variant="body_copy_2" strong align="center" className={percentStyle}>
                        {percent === null ? "-" : percent > 0 ? `+${percent}%` : `${percent}%`}
                        {percent !== null && percent !== 0 ? (
                            <ArrowIcon size="2" fill="#fff" className={percent > 0 ? arrowUpStyle : arrowDownStyle} />
                        ) : (
                            <span className={lineStyle} />
                        )}
                    </Text>
                </div>
                <Text variant="info_txt_3">Rok do roku</Text>
            </div>
        </div>
    );
};

const infoBoxStyle = css({
    backgroundColor: "var(--colors-primary)",
    padding: 3,
    borderRadius: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    width: "100%",
    maxWidth: "360px",
    md: {
        // RP-795: the row carries up to 4 tiles now - equal flex shares replace the former 25% / 33% caps, which overflowed with the median tile added
        flex: "1 1 0",
        minWidth: 0,
        justifyContent: "center"
    }
});

const priceStyle = css({
    marginBottom: 0.5
});

const smallBoxStyle = css({
    backgroundColor: "var(--colors-secondary)",
    color: "var(--colors-white)",
    padding: 1,
    borderRadius: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: 1
});

const percentStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});

const arrowUpStyle = css({
    marginLeft: 1,
    transform: "scale(2) rotate(90deg)"
});

const arrowDownStyle = css({
    marginLeft: 1,
    transform: "scale(2) rotate(-90deg)"
});

const lineStyle = css({
    display: "inline-block",
    width: "0.8rem",
    height: "1px",
    marginLeft: 1,
    border: "1px solid white"
});
